import { EDescriptionQualityReason } from '../model/types'

export const getActionableDescriptionQualityReasons = (
  reasons: EDescriptionQualityReason[]
): EDescriptionQualityReason[] =>
  reasons.filter((reason) => reason !== EDescriptionQualityReason.NoAction)
